import React from "react";
import img from "../../assets/image/maintenance.png";

const Maintenance = () => {

  return (
    <>
      <img
        src={img}
        alt=""
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100vw'
        }}
      />
    </>
  );
};

export default Maintenance;
